import { useEffect, useState } from 'react'
import { useWindow } from './use.window'

export const useWindowScroll = (minDelta: number = 1) => {
  const window = useWindow()

  function getScroll(): number {
    if (!window) {
      return 0
    }

    if (window.scrollY !== void 0) {
      return window.scrollY
    }
    if (window.pageYOffset === void 0) {
      return window.pageYOffset
    }

    return 0
  }

  const [windowScroll, setWindowScroll] = useState<number>(getScroll())

  useEffect(() => {
    if (!window) {
      return
    }

    function handleScroll() {
      const next = getScroll()

      if (Math.abs(next - windowScroll) < minDelta) {
        // skip if there would be too many updates
        return
      }

      setWindowScroll(next)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('resize', handleScroll)
  }, [window]) // Empty array ensures that effect is only run on mount and unmount

  return windowScroll
}
